export class CashAdvance {
    id: number;
    recieverId: number;
    amount: number;
    releasedById: number;
    dateRecieved: string;
    reason: string;
    
    reciever: string; //for display only
    releasedBy: string; //for display only

    createdDate: string;
    createdBy: string;
    updatedDate: string;
    updatedBy: string;
}


// WEBPACK FOOTER //
// ./src/app/models/cashAdvances/cash.advance.ts